<template>
  <div class="pa-6">
    <!-- Filters -->
    <div class="d-flex flex-wrap mb-6">
      <v-chip-group
          v-model="activeHistoryFilter"
          mandatory
          active-class="primary--text text--accent-4"
          column
      >
        <v-chip
            v-for="filter in historyFilters"
            :key="filter.id"
            :value="filter.id"
            filter
            outlined
            class="mr-2 mb-2"
            style="border-color: #E0E0E0;"
        >
          {{ filter.label }}
        </v-chip>
      </v-chip-group>
    </div>

    <!-- Timeline Title -->
    <div class="subtitle-1 grey--text text--darken-1 mb-6">Histórico de cotações</div>

    <!-- Timeline -->
    <div class="history-timeline pl-2">
      <div v-for="(event, index) in historyEvents" :key="event.id" class="d-flex align-start mb-6 relative history-item">
        <!-- Timeline Line -->
        <div class="timeline-line" :class="{ 'last-item': index === historyEvents.length - 1 }"></div>

        <!-- Dot -->
        <div class="timeline-dot mr-4 mt-1">
          <div class="inner-dot"></div>
        </div>

        <!-- Content -->
        <div>
          <div class="text-caption font-weight-bold grey--text text--darken-3 mb-1">
            {{ event.date }} • {{ event.time }}
          </div>
          <div class="text-body-2 grey--text text--darken-2">
            {{ event.description }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, watch } from 'vue';
import useDetalhesCotacaoHistoricoTab from "@/components/webcotacao/composables/useDetalhesCotacaoHistoricoTab";

const props = defineProps({
  idCotacao: {
    type: Number,
    default: null
  }
});

const {
  historyFilters,
  activeHistoryFilter,
  historyEvents,
  fetchHistoryLogs
} = useDetalhesCotacaoHistoricoTab();

watch(() => props.idCotacao, (newVal) => {
  if (newVal) {
    fetchHistoryLogs(newVal);
  }
}, { immediate: true });

watch(activeHistoryFilter, () => {
    if (props.idCotacao) {
        fetchHistoryLogs(props.idCotacao);
    }
});

</script>

<style scoped>
.history-timeline {
  position: relative;
}

.timeline-line {
  position: absolute;
  left: 15px; /* Center of the dot (7px + 4px margin + padding) */
  top: 20px;
  bottom: -30px; /* Extend to next item */
  width: 2px;
  background-color: #4285F4;
  z-index: 1;
}

.history-item:last-child .timeline-line {
  display: none;
}

.timeline-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid #4285F4; /* Blue border */
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  position: relative;
  flex-shrink: 0;
}

.inner-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #E8F0FE; /* Light blue center */
}
</style>
